import {useEffect, useState} from 'react';
import {fetchRequest} from '@bidmii/common/lib/util/FetchRequest';
import {apiRootState} from '../recoil/rootAtom';
import {useRecoilValue} from 'recoil';
import * as Sentry from '@sentry/react';

export default function useCategories(props?: $TSFixMe) {
  const apiRoot = useRecoilValue(apiRootState);
  const [page, setPage] = useState(0);
  const [categories, setCategories] = useState([]);

  // FIXME: This should be a simple fetch request in whatever file it's needed in
  const getCategories = () => {
    // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
    const url = apiRoot._links.categories.href.replace(
      'page=0',
      `page=${page}`,
    );
    fetchRequest(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    })
      .then((response) => response.json())
      .then((res) => {
        if (res._embedded) {
          // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'any[]' is not assignable to para... Remove this comment to see the full error message
          setCategories((prev) => [...prev, ...res._embedded.models]);
        }

        if (res?.page && page < res.page.totalPages - 1) {
          setPage((currentPage) => currentPage + 1);
        }
      })
      .catch((err) => {
        process.env.NODE_ENV === 'development' && console.log(err);
        Sentry.withScope(function (scope) {
          scope.setTag('section', 'useCategories.tsx getCategories()');
          Sentry.captureException(err);
        });
      });
  };

  useEffect(() => {
    if (apiRoot && categories.length === 0) {
      getCategories();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [apiRoot, page]);

  return categories;
}
